import { Link } from "@quintype/components";
import React, { useEffect, useState } from "react";
import Newsletter from "../other-icons/Newsletter";
import "./subscribe-to-newsletter.m.css";

function SubscribeToNewsletter() {
  const [isMobile, setMobile] = useState(false);

  useEffect(() => {
    if (window && window.innerWidth < 767) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, []);
  if (isMobile) {
    return (
      <div styleName="wrapper">
        <Link target="_blank" href="https://www.deccanherald.com/newsletters" styleName="newsletter-link">
          Subscribe to Newsletters <Newsletter color="black" height="14px" width="14px" />
        </Link>
      </div>
    );
  } else {
    return (
      <div styleName="wrapper">
        <Link target="_blank" href="https://www.deccanherald.com/newsletters" styleName="newsletter-link">
          Subscribe to Newsletters
        </Link>
      </div>
    );
  }
}

export default SubscribeToNewsletter;
